import { Address } from "@medusajs/medusa"
import { useState, useEffect } from "react"

import { medusaClient } from "@lib/config"

export const useGetCartAddress = (cartId: string | null, addressUpdateTrigger: number, isShippingMethodSet: boolean) => {
  const [cartAddress, setCartAddress] = useState<Address | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchCartAddress = async () => {
      setIsLoading(true)

      if (cartId && isShippingMethodSet) {
        try {
          const { cart } = await medusaClient.carts.retrieve(cartId)
          if (cart.shipping_address) {
            setCartAddress(cart.shipping_address)
          } else {
            setCartAddress(null)
          }
        } catch (err) {
          setError(err instanceof Error ? err : new Error("An unknown error occurred"))
        } finally {
          setIsLoading(false)
        }
      }
    }

    fetchCartAddress()
  }, [cartId, addressUpdateTrigger, isShippingMethodSet])

  return { cartAddress, isLoading, error }
}
